import startSendGuestContact from './actions/start-send-guest-contact';

export default {
  init(){
    // Add global click event listener for elements with data-action attribute
    // Call action based on that attribute value...

    document.addEventListener('click', evt => {
      const $el = (evt.target ? evt.target.closest('[data-action]') : null);

      if($el){
        const action = $el.getAttribute('data-action');

        if(!action){
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        if(action === 'startSendGuestContact'){
          const contactType = $el.getAttribute('data-contact-type');

          if(contactType === 'aboutRegistration'){
            startSendGuestContact(contactType);
            return;
          }

          if(contactType === 'contactUs'){
            startSendGuestContact(contactType);
            return;
          }

          if(contactType === 'aboutProduct'){
            const productId = $el.getAttribute('data-product-id');
            startSendGuestContact(contactType, { productId });
            return;
          }
          return;
        }

        return;
      }
    });
  }
};
